import { useState } from "react";
import InsolvencyListModal from "@/components/insolvencies/insolvency-list-modal";
import { InsolvencyBanner } from "@/components/insolvencies/insolvency-banner";

interface InsolvencyWarningBadgeProps {
  userId: string;
  userName: string;
  expedientsId?: string[];
  hasActiveInsolvencies?: boolean;
}

export const InsolvencyWarningBadge = ({
  userId,
  userName,
  expedientsId,
  hasActiveInsolvencies,
}: InsolvencyWarningBadgeProps) => {
  const [open, setOpen] = useState(false);

  if (!hasActiveInsolvencies) {
    return null;
  }

  return (
    <div>
      <InsolvencyBanner
        title="Tiene infracciones que debe pagar antes de la resolución del trámite"
        description="Si no se realiza el pago, la solicitud podría ser denegada."
        onClick={() => setOpen(true)}
      />
      <InsolvencyListModal
        isOpen={open}
        onClose={() => setOpen(false)}
        userId={userId}
        userName={userName}
        expedientsIds={expedientsId}
      />
    </div>
  );
};

export default InsolvencyWarningBadge;
